const init = () => {
	document.addEventListener('DOMContentLoaded', function () {
		const slides = document.querySelectorAll('.slide-circle-content');

		slides.forEach((slide) => {
			const container = slide;
			const h2 = container.querySelector('h2');
			const tabs = container.querySelector('.tab-content');
			const audiencep = container.querySelector('.content p');
			const button = container.querySelector('#toggle-card');
			const brandNumber = container.querySelector('.brand-number');
			const headline = container.querySelector('.headline');
			const contentp = container.querySelector(
				'.client-content-animate-common .content p'
			);
			const contentheadline = container.querySelector(
				'.client-content-animate-common h1'
			);

			const culturedescription = container.querySelector(
				'p.culture-description'
			);
			const culturep = container.querySelector('.content p');
			const cultureheadline =
				container.querySelector('.culture-slide h1');

			let isMoved = false;

			button.addEventListener('click', () => {
				const stateElements = [h2, brandNumber, button];
				if (tabs) stateElements.push(tabs); // Only add tabs if it exists
				const state = Flip.getState(stateElements);
				if (!isMoved) {
					if (tabs) tabs.style.display = 'block';
					h2.style.opacity = 0;
					brandNumber.style.opacity = 0;
					button.textContent = 'Close Details';
					container.classList.add('back-slide-content');

					// Use Flip to animate state transition
					Flip.from(state, {
						duration: 0.7,
						scale: 1,
						ease: 'power1.inOut',
						onUpdate: () => {
							// Position and scale transitions for h2
							gsap.to(h2, {
								scale: 1,
								x: 0,
								duration: 0.9,
								opacity: 1,
							});
							if (audiencep)
								gsap.to(audiencep, { scale: 1, duration: 0.9 });
							gsap.to(button, {
								scale: 1,
								duration: 0.4,
								ease: 'power1.inOut',
							});
						},
					});
					//const currentY = gsap.getProperty(contentp, "y");

					gsap.fromTo(
						contentp,
						{ x: 250, y: -300, opacity: 0 }, // Initial position
						{
							x: 0,
							y: 0,
							duration: 0.7,
							opacity: 1,
							ease: 'power2.inOut',
						} // Target position
					);

					// Fade in tabs and brandNumber separately
					if (tabs)
						gsap.to(tabs, { duration: 0.3, display: 'block' });
					gsap.to(brandNumber, {
						opacity: 0,
						duration: 0.3,
						display: 'none',
					});
					gsap.fromTo(
						culturedescription,
						{ x: -435, y: -165, scale: 1.2, opacity: 0.5 }, // Initial position
						{
							x: 0,
							y: 0,
							duration: 0.7,
							scale: 1,
							opacity: 1,
							ease: 'power2.inOut',
						} // Target position
					);
					gsap.fromTo(
						audiencep,
						{ x: -435, y: -165, scale: 1.2, opacity: 0.5 }, // Initial position
						{
							x: 0,
							y: 0,
							duration: 0.7,
							scale: 1,
							opacity: 1,
							ease: 'power2.inOut',
						} // Target position
					);
				} else {
					if (tabs) tabs.style.display = 'none';
					container.classList.remove('back-slide-content');
					h2.style.opacity = 1;
					brandNumber.style.opacity = 1;
					button.textContent = 'Learn More';

					// Reset position of h2
					gsap.set([brandNumber, button], { clearProps: 'all' });

					// Use Flip to animate state transition back
					Flip.from(state, {
						duration: 0.7,
						ease: 'power1.inOut',
						onUpdate: () => {
							// Position and scale transitions for h2
							gsap.to(h2, {
								scale: 1,
								x: 0,
								duration: 0.3,
								opacity: 1,
							});
							if (audiencep)
								gsap.to(audiencep, { scale: 1, duration: 0.9 });
							gsap.to(button, {
								opacity: 1,
								scale: 1,
								duration: 0.4,
								ease: 'power1.inOut',
							});
						},
					});
					if (tabs) gsap.to(tabs, { duration: 0.3, display: 'none' });
					gsap.to(brandNumber, {
						opacity: 1,
						duration: 0.3,
						display: 'block',
					});
					gsap.fromTo(
						contentp,
						{ x: -250, y: 300, opacity: 0 }, // Initial position
						{
							x: 0,
							y: 0,
							duration: 0.7,
							opacity: 1,
							ease: 'power2.inOut',
						} // Target position
					);
					gsap.fromTo(
						contentheadline,
						{ x: -150, y: -130, scale: 0.8 }, // Initial position
						{
							x: 0,
							y: 0,
							duration: 0.7,
							scale: 1,
							ease: 'power2.inOut',
						} // Target position
					);

					gsap.fromTo(
						cultureheadline,
						{ x: -150, y: -130, scale: 0.8 }, // Initial position
						{
							x: 0,
							y: 0,
							duration: 0.7,
							scale: 1,
							ease: 'power2.inOut',
						} // Target position
					);
					gsap.fromTo(
						culturep,
						{ x: 172, y: 230, scale: 0.8, opacity: 0.5 }, // Initial position
						{
							x: 0,
							y: 0,
							duration: 0.7,
							scale: 1,
							opacity: 1,
							ease: 'power2.inOut',
						} // Target position
					);
				}

				isMoved = !isMoved;
			});
		});
	});
};

export { init };
